import React from 'react';
import {PropTypes} from 'prop-types';
import {connect} from 'react-redux';
import DialogueTitle from 'components/DialogueTitle';
import DialogueButtons from 'components/DialogueButtons';
import Modal from 'react-modal';
import Resources from 'utilities/Resources';
import 'styles/exports.scss';

class GraphDataErrorDialogue extends React.Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    graphs: PropTypes.array.isRequired,
    onClose: PropTypes.func.isRequired
  };

  close = () => {
    this.props.onClose();
  };

  render() {
    const resources = Resources.localizedString;
    return (
      <Modal
      className={"dialogue"}
      contentLabel="Graph Data Error Modal"
      onRequestClose={this.close}
      onClose={this.close}
      isOpen={this.props.isOpen}
      style={{
        content: {
          width: 950,
          height: 420
        }
      }}>
        <DialogueTitle title={resources.requestTimedOut} />
        <div className="padded margin-vertical">
          <div className="padded margin-vertical text-center">
            <span className="status-icon status-icon--error margin-bottom"></span>
            <p className="margin-top">{resources.graphTimeoutError}</p>
            <p>{resources.pleaseTryAgainInFewMinutes}</p>
            <p>
              {this.props.graphs && this.props.graphs.map((graph, index) => {
                return (<span key={index} className="block">{`${resources.graph} ${graph}`}</span>);
              })}
            </p>
          </div>
        </div>
        <DialogueButtons
          showCancelButton={false}
          confirmFunction={this.close}
          confirmButtonText={resources.ok} />
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return {
  };
}
export {GraphDataErrorDialogue as GraphDataErrorDialogueNoRedux};

const ConnectedGraphDataErrorDialogue = connect(mapStateToProps, mapDispatchToProps)(GraphDataErrorDialogue);
export default ConnectedGraphDataErrorDialogue;